import React from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, cellWidth, ImgCell, tooltipClick } from '@/components/TableCell';
import styles from './TableList.module.scss';
import { TableActionType as ta } from '@/util/enum';
import { TableFields as tf, State } from '../types';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '周期',
            dataIndex: tf.time,
            key: tf.time,
            width: '10%',
            align: 'center',
            render: (text, record) => tooltipClick(text, () => {
                this.props.tableAction(record.id, ta.detail, record);
            })
        },
        {
            title: '图片',
            dataIndex: tf.imgUrl,
            key: tf.imgUrl,
            width: '10%',
            align: 'center',
            render: ImgCell
        },
        {
            title: '状态',
            dataIndex: tf.state,
            key: tf.state,
            align: 'center',
            onCell: tooltipStyle,
            width: '10%',
            render: (text) => <div>{text == '1' && tf.imgUrl ? '已开启' : '已关闭'}</div>
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: '10%',
            align: 'center',
            render: (text, item) => this._renderActionCell(item.id, item)
        }
    ]);

    _renderActionCell = (key, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(key, ta.edit, record)}>编辑</div>
                {record[tf.state] === State.close && <div className={styles.item} onClick={() => tableAction(record[tf.state], ta.state, record)}>开启</div>}
                {record[tf.state] === State.start && <div className={styles.item} onClick={() => tableAction(record[tf.state], ta.state, record)}>关闭</div>}
            </div>
        );
    }

    render() {
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._takeColumns()}
                    dataSource={this.props.renderData}
                    pagination={false}
                    scroll={{ y: true }}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.array.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;